import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import {
    Card,
    CardContent,
    Typography,
    IconButton,
    Chip,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import GroupsIcon from '@mui/icons-material/Groups';
import styled from 'styled-components';
import { UsuarioContext } from '../providers/personaContext';


const CarruselCategorias = ({
    empresas = [],
    departamentos = [],
    todosLosNegocios = [],
    documentosUsuario = 0,
    documentosGenerales = 0,
    documentosNegocios = {},
    documentosDepartamentos = {}
}) => {

    const navigate = useNavigate();
    const { imgPerfil } = useContext(UsuarioContext);
    const [indexEmpresa, setIndexEmpresa] = React.useState(0);
    const [indexDepartamento, setIndexDepartamento] = React.useState(0);
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    const handleNavegar = (tipo, id = null) => {
        const params = new URLSearchParams();
        params.set('tipo', tipo);
        if (id !== null) {
            params.set('id', id);
        }
        navigate(`?${params.toString()}`);
    };

    const getItemsPerView = (totalItems) => {
        if (windowWidth < 768) return 1; 

        if (totalItems <= 4) return totalItems;

        if (windowWidth < 1200) return 3;
        return 4;
    };

    const itemsPerViewEmpresa = getItemsPerView(empresas.length);
    const itemsPerViewDepartamento = getItemsPerView(departamentos.length);

    const itemWidthEmpresa = 100 / itemsPerViewEmpresa;
    const itemWidthDepartamento = 100 / itemsPerViewDepartamento;

    const maxIndexEmpresa = Math.max(0, empresas.length - itemsPerViewEmpresa);
    const maxIndexDepartamento = Math.max(0, departamentos.length - itemsPerViewDepartamento);

    const handlePrevEmpresa = () => {
        setIndexEmpresa(prev => Math.max(0, prev - 1));
    };

    const handleNextEmpresa = () => {
        setIndexEmpresa(prev => Math.min(maxIndexEmpresa, prev + 1));
    };

    const handlePrevDepartamento = () => {
        setIndexDepartamento(prev => Math.max(0, prev - 1));
    };

    const handleNextDepartamento = () => {
        setIndexDepartamento(prev => Math.min(maxIndexDepartamento, prev + 1));
    };

    const offsetEmpresa = empresas.length > 0 ? -(indexEmpresa * (100 / empresas.length)) : 0;
    const offsetDepartamento = departamentos.length > 0 ? -(indexDepartamento * (100 / departamentos.length)) : 0;

    const totalPagesEmpresa = Math.max(1, maxIndexEmpresa + 1);
    const totalPagesDepartamento = Math.max(1, maxIndexDepartamento + 1);

    const mostrarControlesEmpresa = empresas.length > itemsPerViewEmpresa;
    const mostrarControlesDepartamento = departamentos.length > itemsPerViewDepartamento;

    const gapSize = 15;

    return (
        <ContainerPrincipal>

            {/* Sección 1: Mis Documentos y Generales */}
            <SeccionFila background="linear-gradient(135deg, rgba(0, 60, 102, 0.03), rgba(0, 100, 160, 0.03))">
                <TituloSeccion>Documentos Personales</TituloSeccion>
                <ContenedorDobleCard>
                    <CardEstilizada elevation={3} onClick={() => handleNavegar('usuario')}>
                        <ContenidoCard>
                            <IconoWrapper>
                                <IconoCirculo>
                                    {imgPerfil ?
                                        <img src={imgPerfil} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                        :
                                        <PersonIcon />
                                    }
                                </IconoCirculo>
                            </IconoWrapper>
                            <SubtituloCard variant="overline">Personal</SubtituloCard>
                            <TituloCard variant="h5">
                                Mis Documentos
                            </TituloCard>
                            <ContadorGrande>
                                {documentosUsuario}
                            </ContadorGrande>
                            <DescripcionCard variant="body2">
                                Documentos personales
                            </DescripcionCard>
                        </ContenidoCard>
                    </CardEstilizada>
                    
                    <CardEstilizada elevation={3} onClick={() => handleNavegar('general')}>
                        <ContenidoCard>
                            <IconoWrapper>
                                <IconoCirculo>
                                    <GroupsIcon />
                                </IconoCirculo>
                            </IconoWrapper>
                            <SubtituloCard variant="overline">General</SubtituloCard>
                            <TituloCard variant="h5">
                                Documentos
                            </TituloCard>
                            <ContadorGrande>
                                {documentosGenerales}
                            </ContadorGrande>
                            <DescripcionCard variant="body2">
                                Documentos generales
                            </DescripcionCard>
                        </ContenidoCard>
                    </CardEstilizada>
                </ContenedorDobleCard>
            </SeccionFila>

            {/* Sección 2: Empresas */}
            <SeccionFila background="linear-gradient(135deg, rgba(0, 100, 160, 0.03), rgba(0, 128, 204, 0.03))">
                <TituloSeccion>Negocios</TituloSeccion>
                <div className="seccion-contenido">
                    {empresas.length > 0 ? (
                        <>
                            <SeccionCarrusel>
                                <CarruselWrapper 
                                    offset={offsetEmpresa} 
                                    isCarousel={mostrarControlesEmpresa} 
                                    totalItems={empresas.length} 
                                    itemsPerView={itemsPerViewEmpresa}
                                >
                                    {empresas.map((empresa) => (
                                        <CardContainer 
                                            key={empresa.Id} 
                                            itemWidth={itemWidthEmpresa} 
                                            gap={gapSize} 
                                            isCarousel={mostrarControlesEmpresa}
                                            itemsPerView={itemsPerViewEmpresa}
                                            totalItems={empresas.length}
                                        >
                                            <CardEstilizada
                                                elevation={3}
                                                onClick={() => handleNavegar('empresa', empresa.Id)}
                                            >
                                                <ContenidoCard>
                                                    {empresa.logo ? (
                                                        <>
                                                            <LogoGrandeWrapper>
                                                                <img
                                                                    src={`${process.env.REACT_APP_API_URL}/api/negocio/logo/${empresa.logo}`}
                                                                    alt={empresa.nombre}
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'contain'
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.target.style.display = 'none';
                                                                        e.target.parentElement.style.display = 'none';
                                                                        const fallbackContainer = e.target.closest('.contenido-card-empresa');
                                                                        if (fallbackContainer) {
                                                                            fallbackContainer.classList.add('mostrar-fallback');
                                                                        }
                                                                    }}
                                                                />
                                                            </LogoGrandeWrapper>
                                                            <ContadorGrande>
                                                                {documentosNegocios[empresa.Id] || 0}
                                                            </ContadorGrande>
                                                            <DescripcionCard variant="body2">
                                                                Documentos del negocio
                                                            </DescripcionCard>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <IconoWrapper>
                                                                <IconoCirculo>
                                                                    <BusinessIcon />
                                                                </IconoCirculo>
                                                            </IconoWrapper>
                                                            <SubtituloCard variant="overline">Negocio</SubtituloCard>
                                                            <TituloCard variant="h5">
                                                                {empresa.nombre || 'Sin nombre'}
                                                            </TituloCard>
                                                            <ContadorGrande>
                                                                {documentosNegocios[empresa.Id] || 0}
                                                            </ContadorGrande>
                                                            <DescripcionCard variant="body2">
                                                                Documentos del negocio
                                                            </DescripcionCard>
                                                        </>
                                                    )}
                                                </ContenidoCard>
                                            </CardEstilizada>
                                        </CardContainer>
                                    ))}
                                </CarruselWrapper>
                            </SeccionCarrusel>

                            {mostrarControlesEmpresa && (
                                <>
                                    <ControlesCarrusel>
                                        <BotonCarrusel
                                            size="small"
                                            onClick={handlePrevEmpresa}
                                            disabled={indexEmpresa === 0}
                                        >
                                            <ChevronLeftIcon />
                                        </BotonCarrusel>
                                        <IndicadorPagina>
                                            {indexEmpresa + 1} / {totalPagesEmpresa}
                                        </IndicadorPagina>
                                        <BotonCarrusel
                                            size="small"
                                            onClick={handleNextEmpresa}
                                            disabled={indexEmpresa >= maxIndexEmpresa}
                                        >
                                            <ChevronRightIcon />
                                        </BotonCarrusel>
                                    </ControlesCarrusel>
                                    <PuntosIndicadores>
                                        {Array.from({ length: totalPagesEmpresa }).map((_, idx) => (
                                            <Punto
                                                key={idx}
                                                activo={idx === indexEmpresa}
                                                onClick={() => setIndexEmpresa(idx)}
                                            />
                                        ))}
                                    </PuntosIndicadores>
                                </>
                            )}
                        </>
                    ) : (
                        <CardDisabled elevation={3}>
                            <ContenidoCard>
                                <IconoWrapper>
                                    <IconoCirculo style={{ opacity: 0.5 }}>
                                        <BusinessIcon />
                                    </IconoCirculo>
                                </IconoWrapper>
                                <SubtituloCard variant="overline">Negocio</SubtituloCard>
                                <TituloCard variant="h5">
                                    Sin Negocios
                                </TituloCard>
                                <ContadorGrande>
                                    0
                                </ContadorGrande>
                                <DescripcionCard variant="body2">
                                    No hay documentos
                                </DescripcionCard>
                            </ContenidoCard>
                        </CardDisabled>
                    )}
                </div>
            </SeccionFila>

            {/* Sección 3: Departamentos */}
            <SeccionFila background="linear-gradient(135deg, rgba(0, 128, 204, 0.03), rgba(0, 100, 160, 0.03))">
                <TituloSeccion>Departamentos</TituloSeccion>
                <div className="seccion-contenido">
                    {departamentos.length > 0 ? (
                        <>
                            <SeccionCarrusel>
                                <CarruselWrapper 
                                    offset={offsetDepartamento} 
                                    isCarousel={mostrarControlesDepartamento}
                                    totalItems={departamentos.length}
                                    itemsPerView={itemsPerViewDepartamento}
                                >
                                    {departamentos.map((departamento) => {
                                        const negociosDelPermiso = departamento.empresasEnPermisos || [];
                                        let subtitulo = 'Sin Negocio';

                                        if (negociosDelPermiso.length > 0) {
                                            const negociosValidas = negociosDelPermiso.filter(empId => empId !== null);

                                            if (negociosValidas.length === 1) {
                                                const negocio = todosLosNegocios.find(neg => neg.Id === negociosValidas[0]);
                                                subtitulo = negocio?.nombre || 'Negocio';
                                            } else if (negociosValidas.length > 1) {
                                                subtitulo = `${negociosValidas.length} Negocios`;
                                            } else if (negociosDelPermiso.includes(null)) {
                                                subtitulo = 'Sin Negocio';
                                            }
                                        }

                                        return (
                                            <CardContainer
                                                key={departamento.Id}
                                                itemWidth={itemWidthDepartamento}
                                                gap={gapSize}
                                                isCarousel={mostrarControlesDepartamento}
                                                itemsPerView={itemsPerViewDepartamento}
                                                totalItems={departamentos.length}
                                            >
                                                <CardEstilizada
                                                    elevation={3}
                                                    onClick={() => handleNavegar('departamento', departamento.Id)}
                                                >
                                                    <ContenidoCard>
                                                        <IconoWrapper>
                                                            <IconoCirculo>
                                                                <GroupsIcon />
                                                            </IconoCirculo>
                                                        </IconoWrapper>
                                                        <SubtituloCard variant="overline">
                                                            <Chip
                                                                label={subtitulo}
                                                                size="small"
                                                                sx={{
                                                                    mb: 1,
                                                                    backgroundColor: 'rgba(0, 60, 102, 0.1)',
                                                                    color: '#003c66',
                                                                    fontWeight: 600,
                                                                    fontSize: '11px'
                                                                }}
                                                            />
                                                        </SubtituloCard>
                                                        <TituloCard variant="h5">
                                                            {departamento.nombre || 'Sin nombre'}
                                                        </TituloCard>
                                                        <ContadorGrande>
                                                            {documentosDepartamentos[departamento.Id] || 0}
                                                        </ContadorGrande>
                                                        <DescripcionCard variant="body2">
                                                            Documentos de departamento
                                                        </DescripcionCard>
                                                    </ContenidoCard>
                                                </CardEstilizada>
                                            </CardContainer>
                                        );
                                    })}
                                </CarruselWrapper>
                            </SeccionCarrusel>

                            {mostrarControlesDepartamento && (
                                <>
                                    <ControlesCarrusel>
                                        <BotonCarrusel
                                            size="small"
                                            onClick={handlePrevDepartamento}
                                            disabled={indexDepartamento === 0}
                                        >
                                            <ChevronLeftIcon />
                                        </BotonCarrusel>
                                        <IndicadorPagina>
                                            {indexDepartamento + 1} / {totalPagesDepartamento}
                                        </IndicadorPagina>
                                        <BotonCarrusel
                                            size="small"
                                            onClick={handleNextDepartamento}
                                            disabled={indexDepartamento >= maxIndexDepartamento}
                                        >
                                            <ChevronRightIcon />
                                        </BotonCarrusel>
                                    </ControlesCarrusel>
                                    <PuntosIndicadores>
                                        {Array.from({ length: totalPagesDepartamento }).map((_, idx) => (
                                            <Punto
                                                key={idx}
                                                activo={idx === indexDepartamento}
                                                onClick={() => setIndexDepartamento(idx)}
                                            />
                                        ))}
                                    </PuntosIndicadores>
                                </>
                            )}
                        </>
                    ) : (
                        <CardDisabled elevation={3}>
                            <ContenidoCard>
                                <IconoWrapper>
                                    <IconoCirculo style={{ opacity: 0.5 }}>
                                        <GroupsIcon />
                                    </IconoCirculo>
                                </IconoWrapper>
                                <SubtituloCard variant="overline">Departamento</SubtituloCard>
                                <TituloCard variant="h5">
                                    Sin Departamentos
                                </TituloCard>
                                <ContadorGrande>
                                    0
                                </ContadorGrande>
                                <DescripcionCard variant="body2">
                                    No hay documentos
                                </DescripcionCard>
                            </ContenidoCard>
                        </CardDisabled>
                    )}
                </div>
            </SeccionFila>
        </ContainerPrincipal>
    );
};

const ContainerPrincipal = styled.div`
    display: grid;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 15px;
    padding: 15px;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    min-height: calc(100vh - 150px); 
    height: auto;
    box-sizing: border-box;

    @media (max-width: 768px) {
        display: block;
        grid-template-rows: auto auto auto;
        height: auto;
        min-height: auto;
        gap: 15px;
        padding: 10px;
    }
`;

const SeccionFila = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%; 
    min-height: 0;
    background: ${props => props.background || 'transparent'};
    border-radius: 16px;
    padding: 12px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    flex: 1; 

    .seccion-contenido {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
    }

    @media (max-width: 768px) {
        height: auto;
        min-height: 300px;
        padding: 10px;
        flex: none;
    }
`;

const TituloSeccion = styled(Typography)`
    font-size: 16px !important;
    font-weight: bold !important;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: #000000ff !important;
    margin-bottom: 10px !important;
    text-align: center;
    opacity: 0.7;
    flex-shrink: 0;
`;

const SeccionCarrusel = styled.div`
    position: relative;
    width: 100%;
    overflow-x: hidden; 
    overflow-y: hidden;
    flex: 1;
    min-height: 0;

    @media (max-width: 768px) {
        flex: 1 1 auto;
        min-height: 250px;
    }
`;

const CarruselWrapper = styled.div`
    display: flex;
    gap: 15px;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
    box-sizing: border-box;

    width: ${props => props.isCarousel ? `${(props.totalItems / props.itemsPerView) * 100}%` : '100%'};
    transform: ${props => props.isCarousel ? `translateX(${props.offset}%)` : 'none'};

    @media (max-width: 768px) {
        gap: 10px;
    }
`;

const CardContainer = styled.div`
    box-sizing: border-box;
    height: 100%;

    ${props => props.isCarousel ? `
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(100% / ${props.totalItems});
    ` : `
        flex: 1;
        min-width: 0;
    `}
`;

const CardEstilizada = styled(Card)`
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden; 
    background: white;
    border-radius: 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid transparent;
    box-sizing: border-box;

    &:hover {
        box-shadow: 0 8px 20px rgba(0, 60, 102, 0.15) !important;
        border-color: rgba(0, 60, 102, 0.2);
    }
`;

const CardDisabled = styled(CardEstilizada)`
    cursor: not-allowed;
    opacity: 0.5;
    background: #f5f5f5;

    &:hover {
        transform: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        border-color: transparent;
    }
`;

const ContenidoCard = styled(CardContent)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 10px !important;
    text-align: center;
    flex: 1;
    overflow: hidden;
    height: 100%;
    box-sizing: border-box;


    @media (max-width: 768px) {
        padding: 28px 15px !important;
    }
`;

const IconoWrapper = styled.div`
    position: relative;
    margin-bottom: 10px;
    flex-shrink: 0;

    @media (max-width: 768px) {
        margin-bottom: 12px;
    }
`;

const LogoGrandeWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 150px;
    margin-bottom: 8px;
    flex-shrink: 0;
`;

const IconoCirculo = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #336385;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 60, 102, 0.3);
    transition: all 0.3s ease;

    ${CardEstilizada}:hover & {
        transform: scale(1.1);
        box-shadow: 0 6px 16px rgba(0, 60, 102, 0.4);
    }

    svg {
        font-size: 28px;
        color: white;
    }

    @media (max-width: 768px) {
        width: 60px;
        height: 60px;

        svg {
            font-size: 32px;
        }
    }

    @media (min-width: 769px) and (max-width: 1200px) {
        width: 45px;
        height: 45px;

        svg {
            font-size: 24px;
        }
    }
`;

const TituloCard = styled(Typography)`
    font-size: 16px !important;
    font-weight: 700 !important;
    color: #336385 !important;
    margin-bottom: 6px !important;
    letter-spacing: -0.3px;
    line-height: 1.3 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    min-height: 36px;
    flex-shrink: 0;

    @media (max-width: 768px) {
        font-size: 16px !important;
        min-height: 42px;
    }

    @media (min-width: 769px) and (max-width: 1200px) {
        font-size: 13px !important;
        min-height: 34px;
    }
`;

const SubtituloCard = styled(Typography)`
    font-size: 10px !important;
    color: #666 !important;
    margin-bottom: 6px !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600 !important;
    flex-shrink: 0;
    
    @media (max-width: 768px) {
        font-size: 10px !important;
        margin-bottom: 8px !important;
    }
`;

const ContadorGrande = styled.div`
    font-size: 32px;
    font-weight: 800;
    background: #336385;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    margin: 8px 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    flex-shrink: 0;

    @media (max-width: 768px) {
        font-size: 42px;
        margin: 10px 0;
    }

    @media (min-width: 769px) and (max-width: 1200px) {
        font-size: 28px;
        margin: 6px 0;
    }
`;

const DescripcionCard = styled(Typography)`
    font-size: 12px !important;
    color: #888 !important;
    font-weight: 500 !important;
    font-style: italic;
    margin-top: 4px !important;
    flex-shrink: 0;

    @media (max-width: 768px) {
        font-size: 11px !important;
    }

    @media (min-width: 769px) and (max-width: 1200px) {
        font-size: 9px !important;
    }
`;

const ContenedorDobleCard = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 100%;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 15px;
    }
`;

const ControlesCarrusel = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
    flex-shrink: 0;

    @media (max-width: 768px) {
        margin-top: 12px;
    }
`;

const BotonCarrusel = styled(IconButton)`
    background: linear-gradient(135deg, #003c66, #0064a0) !important;
    color: white !important;
    box-shadow: 0 2px 8px rgba(0, 60, 102, 0.3) !important;
    transition: all 0.3s ease !important;
    width: 32px !important;
    height: 32px !important;

    &:hover {
        background: linear-gradient(135deg, #336385, #0a3b5d) !important;
        transform: scale(1.1);
    }

    &:disabled {
        background: #e0e0e0 !important;
        color: #999 !important;
        box-shadow: none !important;
        opacity: 0.4;
    }

    svg {
        font-size: 20px;
    }
`;

const IndicadorPagina = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    background: rgba(0, 60, 102, 0.08);
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    color: #336385;
    min-width: 65px;
    justify-content: center;
`;

const PuntosIndicadores = styled.div`
    display: flex;
    justify-content: center;
    gap: 5px;
    margin-top: 8px;
    flex-shrink: 0;
`;

const Punto = styled.div`
    width: ${props => props.activo ? '18px' : '6px'};
    height: 6px;
    border-radius: 3px;
    background: ${props => props.activo
        ? '#336385'
        : 'rgba(0, 60, 102, 0.25)'};
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        background: ${props => props.activo
            ? '#336385'
            : 'rgba(0, 60, 102, 0.5)'};
    }
`;

export default CarruselCategorias;